<template>
  <div class="header" :class="itemIsShow ? 'itemShow' : 'itemHiddent'">
    <div class="search" @click="searchClick">搜一搜 发现更多</div>
    <div v-if="itemIsShow" class="tab">
      <div @click="tabItemClick(1)">
        <span>最新</span>
      </div>
      <div @click="tabItemClick(2)">
        <span>关注</span>
      </div>
      <div @click="tabItemClick(3)">
        <span>活动</span>
      </div>
      <div @click="tabItemClick(4)">
        <span>商城</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeHeader",
  components: {},
  props: {
    itemIsShow: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    tabItemClick(index) {
      this.$emit("tabItemClick", index);
    },
    searchClick() {
      this.$emit("searchClick");
    },
  },
  watch: {},
};
</script>
<style scoped>
.header {
  position: fixed;
  z-index: 3;
  top: 0;
  width: 100%;
  background-color: var(--color-main);
}
.itemHiddent {
  height: 80px;
}
.itemShow {
  height: 100px;
}

.header .search {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 335px;
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  text-align: center;
  font-size: 13px;
  color: #717171;
  background-color: #fff;
}
.header .tab {
  position: absolute;
  display: flex;
  top: 65px;
  left: 20px;
  width: 335px;
  background-color: var(--color-main);
}
.header .tab div {
  flex: 1;
  display: flex;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.header .tab div span {
  margin-left: 5px;
}
</style>